import { euJointFits } from './methods.js';
// Wat er aan de mazhab (rechtsschool) van het gezin hangt (golf 6c, oprichter 26-09, f2-14;
// 0045_mazhab). Puur en ES2018 (de kiosk typecheckt de gebedsbestanden). Nooit afgeleid uit een
// keuken, traditie of nationaliteit: alleen uit wat het gezin zelf koos (MADHABS, of null = "weet
// ik niet").
//
// 1. De Asr-tijd. Hanafi rekent Asr vanaf schaduw = 2x (later op de middag), Shafi'i, Maliki en
//    Hanbali vanaf 1x. MAAR: de gepubliceerde kalenders van Diyanet en van de Europese
//    gezamenlijke kalender (Diyanet · Milli Görüş) geven voor ikindi de eerste tijd (asr-ı evvel),
//    ook voor hun Hanafi-gemeenschap (Diyanet volgt daar Abu Yusuf en Muhammad al-Shaybani, de twee
//    leerlingen van Abu Hanifa). Onze berekening van die kalenders klopt alleen met die tijd tegen
//    de gepubliceerde tabellen (calc.eujoint.test.ts, review-g6b-fs-r1.test.ts). Een Hanafi-gezin
//    met die kalender krijgt dus de tijd van de kalender (de moskee), en kan zelf "Hanafi" kiezen
//    voor de latere tijd (asr-ı sani). Bij de andere methoden volgt Asr de mazhab.
// 2. De bron van de tijden: bij Hanafi stellen we de gezamenlijke kalender van Diyanet en Milli
//    Görüş voor (in Europa; daarbuiten Diyanet). Een voorstel met één tik, nooit stil toegepast op
//    een bestaand huishouden. Bij de andere scholen blijft de standaard (MWL).
//
// Een eigen keuze voor Asr ("zelf ingesteld", asr_school_source 'manual') wint altijd en blijft
// staan als de mazhab verandert; "volgt je mazhab" ('madhab') rekent opnieuw bij elke wijziging van
// de mazhab of de methode.
/** Waar de Asr-keuze vandaan komt: de mazhab van het gezin, of zelf ingesteld. */
export const ASR_SCHOOL_SOURCES = ['madhab', 'manual'];
/**
 * Methoden die een gepubliceerde kalender volgen met hun eigen Asr-tijd (asr-ı evvel), ook voor
 * Hanafi's. Daar volgt de standaard de kalender, niet de mazhab.
 */
export const CALENDAR_ASR_METHODS = ['diyanet', 'eu_joint'];
/** Volgt deze methode een kalender met een eigen Asr-tijd (diyanet, eu_joint)? */
export function methodFixesAsr(method) {
    return CALENDAR_ASR_METHODS.indexOf(method) >= 0;
}
/** De Asr-school die bij de mazhab hoort (zie boven); zonder mazhab: standaard. */
export function asrSchoolForMadhab(madhab, method) {
    if (methodFixesAsr(method))
        return 'standard';
    return madhab === 'hanafi' ? 'hanafi' : 'standard';
}
export function asrReason(madhab, method) {
    if (madhab === null)
        return 'no_madhab';
    if (madhab === 'hanafi' && methodFixesAsr(method))
        return 'calendar';
    return madhab === 'hanafi' ? 'hanafi' : 'other_madhab';
}
/**
 * De Asr-school die geldt: zelf ingesteld wint altijd; anders volgt hij de mazhab (en de methode).
 */
export function effectiveAsrSchool(source, stored, madhab, method) {
    return source === 'manual' ? stored : asrSchoolForMadhab(madhab, method);
}
/**
 * De bron van de tijden die bij de mazhab past: Hanafi = de gezamenlijke kalender van Diyanet en
 * Milli Görüş waar die gemeten is (euJointFits: land en breedte ≤ 56°, golf 6b live r1); daarbuiten
 * Diyanet. De andere scholen: geen eigen voorstel (null), de gewone standaard blijft.
 */
export function methodForMadhab(madhab, countryCode = null, lat = null) {
    if (madhab !== 'hanafi')
        return null;
    return euJointFits(countryCode, lat) ? 'eu_joint' : 'diyanet';
}
/**
 * Het voorstel op de pagina Gebedstijden en bij de onboarding: de methode die bij de mazhab past,
 * alleen als het gezin nu iets anders gebruikt. Nooit stil toegepast: de ouder tikt "Gebruik deze
 * kalender".
 */
export function methodSuggestion(madhab, current, countryCode = null, lat = null) {
    const want = methodForMadhab(madhab, countryCode, lat);
    return want !== null && want !== current ? want : null;
}
//# sourceMappingURL=madhab.js.map